import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PreorderFormSettings } from '../interfaces/admintool/preorder-form-settings';
import { environment } from 'src/environments/environment';
import { AdminMenuItem } from '../interfaces/admintool/admin-menu-item';
import { AdminArticleGroup } from '../interfaces/admintool/admin-article-group';
import { ApplicationService } from './application.service';
import { PreorderSettings } from '../interfaces/settings/preorder-settings';
import { map } from 'rxjs';
import { ReplenishmentSettings } from '../interfaces/replenishment-settings';
import { CreateFilterData } from '../interfaces/admintool/create-filter-data';
import { Synonym } from '../interfaces/admintool/synonym';
import { Observable } from 'rxjs';
import { MenuItem } from 'src/app/interfaces/admintool/menu-item.interface';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  constructor(private http: HttpClient, private applicationService: ApplicationService) {}

  getArticleGroups() {
    return this.http.get(`${environment.apiendpoint}admin/groups`)
  }

  getGroups() {
    return this.http.get(`${environment.apiendpoint}admin/groups`)
  }

  createGroup(
    rank: number,
    description: string,
    parentId: string,
    labels: any,
    classificationCodes: string[]
  ) {
    return this.http.post(`${environment.apiendpoint}admin/groups`, {
      label: description,
      labels: labels,
      rank: rank,
      parent_id: parentId,
      classification_codes: classificationCodes
    });
  }

  updateGroup(item: AdminArticleGroup, languageDescription: any) {
    return this.http.put(`${environment.apiendpoint}admin/groups/${item.id}`, {
      id: item.id,
      label: item.label,
      labels: languageDescription,
      rank: item.rank,
      company_group_code: item.company_group_code,
      parent_id: item.parent_id,
      classification_codes: item.classification_codes
    });
  }

  deleteGroup(item: AdminArticleGroup) {
    return this.http.delete(`${environment.apiendpoint}admin/groups/${item.id}`);
  }

  rankUpGroup(item: AdminArticleGroup) {
    return this.http.put(`${environment.apiendpoint}admin/groups/${item.id}/up`, {});
  }

  rankDownGroup(item: AdminArticleGroup) {
    return this.http.put(`${environment.apiendpoint}admin/groups/${item.id}/down`, {});
  }

  groupFilters(id: string) {
    return this.http.get(`${environment.apiendpoint}admin/specs/groups/${id}/filters`);
  }

  groupSpecs(id: string) {
    return this.http.get(`${environment.apiendpoint}admin/groups/${id}/specs`);
  }

  getSpec(groupId: string, specCode: string) {
    return this.http.get(`${environment.apiendpoint}admin/groups/${groupId}/specs/${specCode}`);
  }

  createFilter(filter: CreateFilterData) {
    return this.http.post(`${environment.apiendpoint}admin/specs/filters`, filter);
  }

  updateFilter(filter: CreateFilterData) {
    return this.http.put(`${environment.apiendpoint}admin/specs/filters`, filter);
  }

  getFilters(filterId: number) {
    return this.http.get(`${environment.apiendpoint}admin/specs/filters/${filterId}`);
  }

  deleteFilter(id: string) {
    return this.http.delete(`${environment.apiendpoint}admin/specs/filters/${id}`);
  }

  // Synonyms
  getSynonyms(languageCode: string) {
    return this.http.get(`${environment.apiendpoint}synonyms/language/${languageCode}`);
  }

  addSynonym(synonym: Synonym, languageCode: string) {
    if (synonym.id) {
      return this.http.put(`${environment.apiendpoint}synonyms`, synonym);
    } else {
      return this.http.post(`${environment.apiendpoint}synonyms`, synonym);
    }
  }

  deleteSynonym(synonym: Synonym) {
    return this.http.delete(`${environment.apiendpoint}synonyms/${synonym.id}`);
  }

  savePreorder(preorderFormSettings: PreorderSettings) {
    return this.http.put(
      `${environment.apiendpoint}companygroups/${this.applicationService.getSelectCompanyGroupCode()}/preordersettings/`,
      preorderFormSettings
    );
  }

  preorderSettings() {
    return this.http.get(`${environment.apiendpoint}companygroups/${this.applicationService.getSelectCompanyGroupCode()}/preordersettings/`);
  }
  menuItems() {
    return this.http.get(`${environment.apiendpoint}admin/root-menu-item`);
  }

  getMenuItem(menuItemId: number) {
    return this.http.get(`${environment.apiendpoint}admin/menu-item/${menuItemId}`);
  }

  addSingleMenuItem(item: MenuItem, parentId?: number) {
    item.parent_menu_item_id = parentId;
    return this.http.post(`${environment.apiendpoint}admin/menu-item`, item);
  }

  updateSingleMenuItem(item: MenuItem) {
    return this.http.put(`${environment.apiendpoint}admin/menu-item/${item.menu_item_id}`, item);
  }

  deleteSingleMenuItem(menuItemId: number) {
    return this.http.delete(`${environment.apiendpoint}admin/menu-item/${menuItemId}`);
  }
  xlSettings() {
    return this.http.get(`${environment.apiendpoint}replenish/settings`);
  }

  saveXl(data: ReplenishmentSettings) {
    return this.http.put(`${environment.apiendpoint}replenish/settings`,data);
  }

  marketplaceSettings() {
    return this.http.get(`${environment.apiendpoint}companygroups/${this.applicationService.getSelectCompanyGroupCode()}/marketplacesettings/`);
  }

  saveMarketplaceSettings(year: string) {
    return this.http.put(`${environment.apiendpoint}companygroups/${this.applicationService.getSelectCompanyGroupCode()}/marketplacesettings/`, {
      company_group_code: this.applicationService.getSelectCompanyGroupCode(),
      block_model_year: year
    });
  }

  getIndexStatus() {
    return this.http.get(`${environment.publicapiendpoint}info/indices/accentry`);
  }

  //SPECS
  specsGreylist() {
    return this.http.get(`${environment.apiendpoint}admin/specs/blacklist`);
  }

  addSpecToBlacklist(specCode: string) {
    return this.http.post(`${environment.apiendpoint}admin/specs/blacklist?c=${specCode}`, {});
  }

  removeSpecFromBlacklist(specCode: string) {
    return this.http.delete(`${environment.apiendpoint}admin/specs/blacklist?c=${specCode}`, {});
  }

  getTranslations(payload: any): Observable<any> {
    return this.http.post(`${environment.apiendpoint}translations/search/?v=1.0`, payload);
  }

  saveTranslation(translation: any): Observable<any> {
    translation['new'] = false; // Ensure the translation is not marked as new
    return this.http.post(`${environment.apiendpoint}translations?authorize`, translation);
  }

  // Recommendations upload (dummy API)
  uploadRecommendations(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiendpoint}articles/recommendations/import?v=1.0`, formData);
  }

  // Must Stock List upload
  uploadMustStockList(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiendpoint}admin/msl/import?v=1.0`, formData);
  }
}
